import { GridItem, SectionMessage } from "@certn/cascadia-react";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { object, string } from "yup";

import { ReferenceCheckTemplatePageLayout } from "../ReferenceCheckTemplatePageLayout";
import { useReferenceCheckTemplatesContext } from "../ReferenceCheckTemplatesContext";
import {
  ReferenceQuantitiesSection,
  TemplateNameField,
} from "../../ReferenceCheckTemplateForm";
import { CustomInstructionsFormSection } from "../../../templates/CustomInstructionsFormSection";
import { REFERENCE_DEFAULT_INSTRUCTIONS } from "../../../templates/customInstructionsConstants";
import { customInstructionsSchemaField } from "../../../templates/customInstructionsValidation";
import {
  REFERENCE_QUANTITY_DEPENDENCY,
  referenceQuantityFieldsSchema,
  type ReferenceCheckTemplateFormValues,
} from "../../utils";

export function ReferenceCheckTemplateDetailsStep() {
  const { t } = useTranslation();
  const { template, setTemplate, goToNextStep } =
    useReferenceCheckTemplatesContext();

  const schema = object().shape(
    {
      name: string().trim().min(1).required().label(t("Template name")),
      ...referenceQuantityFieldsSchema(),
      custom_instructions: customInstructionsSchemaField(),
    },
    [REFERENCE_QUANTITY_DEPENDENCY]
  );

  return (
    <Formik<ReferenceCheckTemplateFormValues>
      initialValues={template}
      validationSchema={schema}
      validateOnMount
      onSubmit={(values) => {
        setTemplate({ ...template, ...values });
        goToNextStep();
      }}
    >
      {({ handleSubmit, isSubmitting, isValid }) => (
        <ReferenceCheckTemplatePageLayout
          onComplete={handleSubmit}
          submitting={isSubmitting}
          disableCompletion={!isValid}
        >
          <TemplateNameField />
          <GridItem>
            <SectionMessage type="info" icon="info">
              {t(
                "Questions and quantity are locked after save, but the template itself is still editable (template name, active state)."
              )}
            </SectionMessage>
          </GridItem>
          <ReferenceQuantitiesSection showHeading={false} />
          <CustomInstructionsFormSection
            fieldName="custom_instructions"
            defaultInstructionsPlaceholder={REFERENCE_DEFAULT_INSTRUCTIONS()}
          />
        </ReferenceCheckTemplatePageLayout>
      )}
    </Formik>
  );
}
